import React, { Fragment } from 'react';
import { string, number, shape } from 'prop-types';
import scrollIt from '../../Base/Scroll';
import classNames from 'classnames';

// Add a discrete word break character to Ungdomsmottagning.
// Use "domsmottagning" (no Ung/ung) to be less case sensetive.
const formatHeadingHtml = (heading) => ({
  __html: heading.replace('domsmottagning', 'doms&shy;mottagning'),
});

const ContactHeader = (Card) => {
  const classes = classNames({
    'contact-header': true,
    'contact-header--no-links': !Card.Address && !Card.Location,
  });

  function openIndoorRouteDescriptionIfClosed() {
    //if panel is closed, open it
    let findUsPanel = document.getElementById('contact');
    if (findUsPanel !== null) {
      let open = document.querySelector('#contact .c-expandable-button').dataset
        .open;
      if (open === 'false')
        document.querySelector('#contact .c-expandable-button').click();
    }

    let indoorRouteDescription = document.getElementById(
      'indoor-route-description'
    );
    if (indoorRouteDescription !== null) {
      let open = document.getElementById('indoor-route-description').dataset
        .open;
      if (open === 'false')
        document.getElementById('indoor-route-description').click();
    }
  }
  const showRouteDescriptionLink = Boolean(
    Card.Address ||
      (Card.Location && Card.Location.latitude && Card.Location.longitude) ||
      Card.IndoorRouteDescription ||
      Card.RoadDescription
  );

  return (
    <header className={classes}>
      <h1
        dangerouslySetInnerHTML={formatHeadingHtml(Card.DisplayName)}
        className="contact-header__heading"
      />
      {Card.LogotypeUrl && (
        <div className="contact-header__logo">
          <img src={Card.LogotypeUrl} alt="Mottagningens logotyp" />
        </div>
      )}
      {Card.Address && (
        <p className="contact-header__address">{Card.Address}</p>
      )}

      {Card.Location && (
        <Fragment>
          <a
            className="contact-header__link contact-header__link--map"
            href={`https://www.google.se/maps/dir/?api=1&destination=${Card.Location.latitude},${Card.Location.longitude}`}
          >
            <span>Visa på karta</span>
          </a>
        </Fragment>
      )}

      {showRouteDescriptionLink && (
        <Fragment>
          {/* On click: Scroll down to find us section and open the indoor route description text */}
          <a
            className="contact-header__link contact-header__link--path"
            onClick={(e) => {
              e.preventDefault();
              scrollIt(
                document.getElementById(`contact`),
                300,
                'easeOutQuad',
                openIndoorRouteDescriptionIfClosed
              );
            }}
            href={`#contact`}
          >
            <span>{Card.Translations.roaddescription}</span>
          </a>
        </Fragment>
      )}
    </header>
  );
};

ContactHeader.propTypes = {
  DisplayName: string,
  Address: string,
  Location: shape({
    latitude: number,
    longitude: number,
  }),
  LogotypeUrl: string,
  Translations: shape({
    roaddescription: string,
  }),
};

export default ContactHeader;
